// @ vendors
const React = require('react');

// @ components
const OKModal = require('components/commons/OKModal/OKModal');

// @ commons
const { FormattedText } = require('core/i18n').i18n;

// @ constants
const { COMMONS } = require('constants/mortgageRequestHolderData');

const content = (
    <React.Fragment>
        <div className="row">
            <div className="col-xs-12 text-center">
                <FormattedText value="mortgageRequestEstates-modalText1" />
            </div>
        </div>
        <div className="row">
            <div className="col-xs-12 text-center">
                <FormattedText
                    injectedStrings={[COMMONS.MORTGAGE_ESTATES_HAS_NS_PHONE]}
                    value="mortgageRequestEstates-modalText2"
                />
            </div>
        </div>
    </React.Fragment>
);

const modal = (onRequestClose = () => { }) => (
    <OKModal
        content={content}
        footerType="action"
        isOpen={true}
        onCloseCallback={onRequestClose}
        onPrimaryButtonClick={onRequestClose}
        primaryButtonText="common-accept"
        title="mortgageRequestEstates-modalTitle"
        titleAlignment="center"
    />
);

module.exports = modal;
